<template>
  <main-content-layout :title="$gettext('DEBIT_STATEMENT')">
    <q-layout data-testid="report-manager" class="q-pa-lg">
    <q-card class="fit">
      <q-card-section class="q-py-xs">
        <div class="report-title">
          {{reportTitle || name}}
        </div>
      </q-card-section>
      <q-card-section>
        <div class="row">
          <JtDynamicForm
            data-testid="form"
            ref="form"
            :inputs="form.inputs"
            :model="form.dadosForm"
            :relacionamentos="form.relacionamentos"
            :interface="form.nmInterface"
            @on-select-change="onSelectChangeHandler"
          />
        </div>
      </q-card-section>
    </q-card>
    <div class="row btn-container q-gutter-md justify-center">
      <q-btn
        data-testid="gerar-btn"
        color="blue-grey-3"
        class="col-2"
        @click="onClear"
      >
        {{ $gettext('CLEAN') }}
      </q-btn>
      <q-btn
        data-testid="gerar-btn"
        color="primary"
        class="col-2"
        @click="onGenerateReportClick"
      >
        {{ $gettext('GENERATE') }}
      </q-btn>
    </div>
     <JtDocsViewer
      :src="fileSrc"
      :title="$gettext('INVOICE_EXTRACT')"
      pdf
      ref="reportModal"
    />
  </q-layout>
  </main-content-layout>
</template>
<script>
import { Component, Vue } from 'vue-property-decorator'
import { JtDocs } from 'jtech-webcomps'
import ServiceRequestDebitStatementController from './ServiceRequestDebitStatementController'
import ServiceRequestController from '../../../../ServiceRequestController'
import MainContentLayout from '../../../Layout/MainContentLayout.vue'

const { JtDocsViewer } = JtDocs

import { QBtn } from 'quasar'

@Component({
  name: 'ServiceRequestDebitStatement',
  components: {
    MainContentLayout,
    QBtn,
    JtDocsViewer
  },
  props: {
    consumerUnit: String,
    protocol: String
  }
})
class ServiceRequestDebitStatement extends Vue {
  controller = ServiceRequestController.getInstance();
  debitStatementController = ServiceRequestDebitStatementController.getInstance();
  fileSrc = null
  form = null;

  async mounted () {
    const formArray = await this.debitStatementController.loadDebitStatementForm()
    this.form = formArray[0]
  }

  async onGenerateReportClick () {
    try {
      const billingEmail = this.controller.state.serviceRequests[this.protocol].consumerUnits[this.consumerUnit].branchOfficeEmail
      const billingPhone = this.controller.state.serviceRequests[this.protocol].consumerUnits[this.consumerUnit].branchOfficePhone
      const address = this.controller.state.serviceRequests[this.protocol].consumerUnits[this.consumerUnit].infoCad.address.find(address => address.type == 20030001)
      const addressString = `${address.addressName} - ${address.number} - ${address.neighborhood} - ${address.city} - ${address.state} - ${this.$gettext('ZIP')} ${address.addressZipCode} ${address.detail == null ? '' : ' - ' + address.detail}`
      this.$emit('generate', {
        consumerUnit: this.consumerUnit,
        owner: this.ownerId,
        dateRangeInicial: this.form.dadosForm.dateRange.inicial,
        dateRangeFinal: this.form.dadosForm.dateRange.final,
        address: addressString,
        branchOfficeEmail: billingEmail,
        branchOfficePhone: billingPhone,
        branchOffice: this.branchOffice,
        branchOfficeName: this.branchOfficeName,
        relFormatoRelatorio: 1,
        relFormaGeracao: 1,
        nmInterface: 'debitStatementReport.debitStatementReport'
      })
      const resolveLogicResult = await this.$jt.repository.resolveLogic(
        'debitStatementReport.debitStatementReport',
        {
          consumerUnit: this.consumerUnit,
          owner: this.ownerId,
          branchOffice: this.branchOffice,
          branchOfficeName: this.branchOfficeName,
          branchOfficeEmail: billingEmail,
          branchOfficePhone: billingPhone,
          dateRangeInicial: this.form.dadosForm.dateRange.inicial,
          dateRangeFinal: this.form.dadosForm.dateRange.final,
          address: addressString,
          relFormatoRelatorio: 1,
          relFormaGeracao: 1
        }
      )
      await this.__whenGenerationFormatIsOnline(resolveLogicResult)
    } catch (error) {
      console.error(error)
    }
  }

  async __whenGenerationFormatIsOnline ({ nmArquivo }) {
    try {
      const result = await this.$jt.repository.downloadFile(
        nmArquivo,
        'pdf',
        '',
        'application/pdf'
      )

      this.fileSrc = URL.createObjectURL(result)
      this.$nextTick(() => {
        this.$refs.reportModal.show()
      })
      return Promise.resolve()
    } catch (error) {
      return Promise.reject(error)
    }
  }

  get ownerDocument () {
    return this.controller.state.serviceRequests[this.protocol].consumerUnits[this.consumerUnit].ownerDocument
  }

  get branchOfficeName () {
    return this.controller.state.serviceRequests[this.protocol].consumerUnits[this.consumerUnit].branchOfficeName
  }

  get branchOffice () {
    return this.controller.state.serviceRequests[this.protocol].consumerUnits[this.consumerUnit].branchOffice
  }

  get ownerId () {
    return this.controller.state.serviceRequests[this.protocol].client
  }
}
export default ServiceRequestDebitStatement
</script>
<style lang="scss" scoped>
@import "tailwindcss/utilities";
.table-header {
  background-color: #f1f1f1;
  margin: 30px;
}
.cell-values {
  display: flex;
  flex-direction: column;
}
.colapse-area {
  background-color: #5898aa;
  display: grid;
  grid-template-columns: 32% 32% 32% 4%;
}
.box-buttom {
    grid-column-start: 4;
    grid-column-end: 5;
    grid-row-start: 1;
    grid-row-end: 3;
    display: flex;
    justify-content: center;
    align-items: center;
    margin-right: 35px;
}

.btn-header {
  color: #333
}
.colapse {
  color: #fff;
  padding: 8px 20px;
}

.row-paint-colapse {
  background-color: #f1f1f1
}

.index {
  border-radius: 25px;
  padding: 2px 10px;
  max-height: 25px;
}
.buttons-area {
  height: 55px;
  display: flex;
}
.index-table {
  width: 50%;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  padding: 0 80px 0 0;
}
.rigth-buttons {
  width: 50%;
  display: flex;
  justify-content: right;
}

.top-area {
  background-color: #f1f1f1;
  display: flex;
  justify-content: space-around;
  padding: 17px 0;
}

.small-span {
  font-weight: 300
}

.block-header {
  display: flex;
  flex-direction: column;
  align-items: center;
}
</style>
